import { Link } from "react-router";
import { useOffering } from "../../navigation/use-offering";
import { shortId } from "../../operations/format";
import { recordLinkFor } from "../record-links";

/**
 * A reference to the record a failure or an audit row is about. A link when the area of that record opens for the staff member (the
 * offering: their roles and the features the API switched on);
 * the type and the short id as plain text when they cannot (or when the record has no screen). The full id is the title, so it can be copied.
 */
export function RecordLink({ type, id }: Readonly<{ type: string; id: string }>) {
  const target = recordLinkFor(type, id, useOffering());
  const text = (
    <>
      {target.label} <code title={id}>{shortId(id)}</code>
    </>
  );
  return target.href === null ? (
    <span className="record-link record-link--plain">{text}</span>
  ) : (
    <Link
      className="record-link inline-flex min-h-11 items-center gap-1 text-link underline underline-offset-4 hover:no-underline compact:min-h-8"
      to={target.href}
    >
      {text}
    </Link>
  );
}
